module.exports = __webpack_public_path__ + "media/images/lb/632-d00381fca26958c6d8ba8d136575a854.svg";